<template>
  <div class="automate">
    <div class="head-box">
      <h4 class="c-flex c-flex-item">
        自动抄送
        <el-popover
          placement="right"
          trigger="hover"
          content="设置抄送规则，匹配规则的工单将自动抄送给对应的人员"
        >
          <i class="el-icon-info f-s-12 c_gray" slot="reference"></i>
        </el-popover>
      </h4>
      <div class="c-flex">
        <el-input
          placeholder="请输入规则名称"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click.native="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-select
          style="margin-left:10px;"
          width="300px"
          v-model="searchOrgId"
          :placeholder="tenantId == '1340835581184723420' ? '服务商筛选' : '适用范围筛选'"
          clearable
          filterable
          value-key="index"
          @change="
            fpi.page = 1;
            getData();
          "
        >
          <el-option
            v-for="(item, index) in options.orgs"
            :key="index"
            :label="item.label"
            :value="item._id"
          ></el-option>
        </el-select>
        <el-button type="primary" class="m-l-10" @click.native="doNew">新增抄送规则</el-button>
      </div>
    </div>
    <div class="content-box">
      <div class="content-table">
        <el-table ref="table" :data="fpi.data" empty-text="暂无数据" height="calc(100% - 50px)">
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doRemove(scope.row._id)">
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <el-table-column prop="order" label="显示顺序" width="100px"></el-table-column>
          <el-table-column
            prop="nameDisp"
            label="显示名称"
            width="300px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="工作流" width="150px" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ formatWorkflowDefId(scope.row.value.workflowDefId) }}
            </template>
          </el-table-column>
          <el-table-column label="节点" width="150px" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ formatNodeId(scope.row.value.workflowDefId, scope.row.value.nodeId) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="value.scopeId"
            :label="tenantId == '1340835581184723420' ? '服务商' : '适用范围'"
            :formatter="formatOrgs"
            width="200px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="value.dispatchHandlerIds"
            :formatter="formatUsers"
            label="抄送给"
            width="200px"
            show-overflow-tooltip
          ></el-table-column>
          <!-- <el-table-column prop="value.priority" label="优先级"></el-table-column> -->
          <el-table-column prop="state" label="状态">
            <template slot-scope="scope">
              <el-tag :type="scope.row.state == 1 ? '' : 'warning'">
                {{ scope.row.state == 1 ? '已启用' : '已禁用' }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog @close="doInit" title="抄送规则" :visible.sync="openDetail" width="700px">
      <el-form
        :model="formData"
        ref="formData"
        :rules="rules"
        label-width="90px"
        label-position="left"
      >
        <el-form-item prop="order" label="显示顺序">
          <el-input-number
            v-model="formData.order"
            :controls="false"
            :precision="0"
            :min="1"
            placeholder="请输入数字"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          prop="nameDisp"
          label="规则名称"
          :rules="{ required: true, trigger: 'blur', message: '名称不能为空' }"
        >
          <el-input v-model="formData.nameDisp"></el-input>
        </el-form-item>
        <el-form-item
          prop="value.workflowDefId"
          label="工作流"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '工作流不能为空'
          }"
        >
          <el-select
            v-model="formData.value.workflowDefId"
            placeholder="请选择工作流"
            filterable
            @change="getNodes(formData.value.workflowDefId, true)"
          >
            <el-option
              v-for="item in options.workflows"
              :key="item._id"
              :label="item.title"
              :value="item._id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="value.nodeId"
          label="节点"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '工作流节点不能为空'
          }"
        >
          <el-select v-model="formData.value.nodeId" placeholder="请选择工作流节点" filterable>
            <el-option
              v-for="item in options.nodes"
              :key="item.nodeId"
              :label="item.name"
              :value="item.nodeId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="value.scopeId"
          :label="tenantId == '1340835581184723420' ? '服务商' : '适用范围'"
        >
          <el-select v-model="formData.value.scopeId" placeholder="请选择" clearable filterable>
            <el-option
              v-for="item in options.orgs"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-tag type="success" size="medium">多条件均满足时规则生效</el-tag>
        </el-form-item>
        <el-form-item
          v-for="(condition, index) of formData.value.conditions"
          :key="index"
          :label="'条件' + (index + 1)"
        >
          <div class="condition-card">
            <el-card shadow="hover">
              <el-form-item label="抄送条件">
                <el-select
                  v-model="formData.value.conditions[index].type"
                  placeholder="请选择"
                  @change="
                    formData.value.conditions[index].value = '';
                    getOptions(formData.value.conditions[index].type);
                  "
                  clearable
                >
                  <el-option
                    v-for="item in options.CCType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!--按省市区-->
              <el-form-item
                v-if="formData.value.conditions[index].type == 'area'"
                :label="'按' + osg.codelabel('CCType', formData.value.conditions[index].type)"
                prop="area"
              >
                <el-cascader
                  v-if="openDetail"
                  :props="area.props"
                  v-model="formData.value.conditions[index].value"
                  clearable
                ></el-cascader>
              </el-form-item>
              <!--按服务区域-->
              <el-form-item
                v-else-if="formData.value.conditions[index].type == 'serviceTerritory'"
                :label="'按' + osg.codelabel('CCType', formData.value.conditions[index].type)"
              >
                <el-select
                  v-model="formData.value.conditions[index].value"
                  placeholder="可搜索服务区域"
                  multiple
                  filterable
                  remote
                  :remote-method="getST"
                  reserve-keyword
                  clearable
                  @change="$forceUpdate()"
                >
                  <el-option
                    v-for="item in options.serviceTerritory"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!--按工作类型-->
              <el-form-item
                v-else-if="formData.value.conditions[index].type == 'workType'"
                :label="'按' + osg.codelabel('CCType', formData.value.conditions[index].type)"
              >
                <el-select
                  v-model="formData.value.conditions[index].value"
                  multiple
                  filterable
                  remote
                  reserve-keyword
                  placeholder="可搜索工作类型"
                  :remote-method="getWorkType"
                  @change="$forceUpdate()"
                  clearable
                >
                  <el-option
                    v-for="item in options.workType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!--按渗漏部位-->
              <el-form-item
                v-else-if="formData.value.conditions[index].type == 'exts.leakagesite_copy'"
                :label="'按' + osg.codelabel('CCType', formData.value.conditions[index].type)"
              >
                <el-cascader
                  v-model="formData.value.conditions[index].value"
                  :options="options.repairParts"
                  :props="{ multiple: true, checkStrictly: true, label: 'name', emitPath: false }"
                  clearable
                ></el-cascader>
              </el-form-item>
              <!--按信息渠道-->
              <el-form-item
                v-else-if="formData.value.conditions[index].type == 'channel'"
                :label="'按' + osg.codelabel('CCType', formData.value.conditions[index].type)"
              >
                <el-cascader
                  v-model="formData.value.conditions[index].value"
                  :options="options.channel"
                  :props="{ multiple: true, checkStrictly: true, label: 'name', emitPath: false }"
                  clearable
                ></el-cascader>
              </el-form-item>
              <!--按其他 档案字段-->
              <el-form-item
                v-else
                :label="'按' + osg.codelabel('CCType', formData.value.conditions[index].type)"
              >
                <el-select multiple v-model="formData.value.conditions[index].value" clearable>
                  <el-option
                    v-for="item in options[formData.value.conditions[index].type]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-card>
            <div class="card-remove">
              <i class="el-icon-remove" @click="removeCondition(index)"></i>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button plain icon="el-icon-plus" class="button_dashed" @click="newCondition">
            新增条件
          </el-button>
        </el-form-item>
        <el-form-item
          prop="value.dispatchHandlerIds"
          label="抄送给"
          :rules="{
            required: true,
            trigger: 'change',
            message: '请选择要抄送的人员'
          }"
        >
          <el-select
            v-model="formData.value.dispatchHandlerIds"
            placeholder="请选择要抄送的人员"
            filterable
            multiple
            clearable
            @change="$forceUpdate()"
          >
            <template v-for="item in options.users">
              <!-- v-if="formData.value.scopeId ? formData.value.scopeId == item.orgId : true" -->
              <el-option :key="item.value" :label="item.label" :value="item.value">
                <span>{{ item.label }}</span>
                <span style="float: right; color: #c3C6CD; font-size: 13px">
                  {{ item.phone }}
                </span>
              </el-option>
            </template>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="优先级">
          <el-input-number
            v-model="formData.value.priority"
            :controls="false"
            :precision="0"
            :min="1"
            :max="100"
            placeholder="输入1-100的数值，默认优先级为100，即最高优先级"
          ></el-input-number>
        </el-form-item> -->
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'Allot',
  data() {
    window.$this = this;
    let that = this;
    return {
      tenantId: '',
      scriptIdentity: '',
      fpi: {},
      searchValue: '',
      searchOrgId: '',
      openDetail: false,
      formData: {
        value: {
          conditions: [{ type: '', value: [] }],
          dispatchHandlerIds: [],
          priority: 100,
          workflowDefId: '',
          nodeId: ''
        }
      },
      rules: this.$util.rules,
      options: {
        codecfg_CCType: { codeId: 'CCType' },
        serviceTerritory: [],
        workType: [],
        cascadeCode_repairParts: [], //维修部位
        cascadeCode_channel: [],
        workflows: [],
        nodes: [],
        users: [],
        orgs: []
      },
      //地址级联-懒加载
      area: {
        props: {
          checkStrictly: true,
          lazy: true,
          async lazyLoad(node, resolve) {
            const { level } = node;
            let nodes = [];
            if (level == '0') {
              nodes = await that.$util.getProvince();
            } else if (level == '1') {
              node.children = [];
              let id = node.data.code;
              nodes = await that.$util.getCity(id);
            } else if (level == '2') {
              node.children = [];
              let id = node.data.code;
              nodes = await that.$util.getDistrict(id);
            }
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }
        }
      }
    };
  },
  mounted() {
    this.tenantId = JSON.parse(sessionStorage['entity']).tenantId;
    this.scriptIdentity = this.osg.param('id');
    this.doInit();
    this.getOrgs();
    this.getUsers();
    this.getWorkflows();
    this.getST();
    this.getWorkType();
    this.osg.codeoption(() => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    formatOrgs(row, column, cellValue) {
      return this.osg.codelabel('orgs', cellValue);
    },
    formatUsers(row, column, cellValue) {
      return this.osg.codelabelForArray('users', cellValue);
    },
    formatWorkflowDefId(workflowDefId) {
      if (workflowDefId && this.options.workflows.length > 0) {
        for (let workflow of this.options.workflows) {
          if (workflowDefId == workflow._id) {
            return workflow.title;
          }
        }
      }
    },
    formatNodeId(workflowDefId, nodeId) {
      if (workflowDefId && nodeId && this.options.workflows.length > 0) {
        for (let workflow of this.options.workflows) {
          if (workflowDefId == workflow._id) {
            for (let node of workflow.def.nodes) {
              if (nodeId == node.nodeId) {
                return node.name;
              }
            }
          }
        }
      }
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = {
        value: {
          conditions: [{ type: '', value: [] }],
          dispatchHandlerIds: [],
          priority: 100,
          workflowDefId: '',
          nodeId: ''
        }
      };
    },
    getUsers() {
      this.osg.ajax(
        'user/query.do',
        {
          _all: 1,
          'is:state|integer#and': 1,
          notFilterBelongTo: '1',
          notFilterOrgId: '1',
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.users = res.data;
        }
      );
    },
    getOrgs() {
      this.osg.ajax(
        'org/query.do',
        {
          _all: '1',
          notFilterBelongTo: '1',
          notFilterOrgId: '1',
          sortField: 'order'
        },
        res => {
          res.data.orgList.map(item => {
            item.label = item.orgName;
            item.value = item._id;
          });
          // res.data.orgList.unshift({
          //   label: res.data.orgName || '顶级组织',
          //   value: res.data._id,
          //   _id: ''
          // });
          this.options.orgs = res.data.orgList;
        }
      );
    },
    getData() {
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'in:state|array-integer#and': '0,1',
        sortField: 'order',
        sortOrder: 'asc',
        'regex:name|string#or': this.searchValue,
        'regex:nameDisp|string#or': this.searchValue,
        'is:value.scopeId|string#and': this.searchOrgId,
        scriptIdentity: this.scriptIdentity
      };
      this.osg.setFpi(params);
      this.osg.ajax('groovyScriptParam/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      this.formData = this.$util.deepCopy(row);
      //为了渲染
      this.getNodes(this.formData.workflowDefId);
      //获取条件字典表选项
      for (let condition of row.value.conditions) {
        this.getOptions(condition.type);
      }
      this.openDetail = true;
    },
    doSave() {
      if (this.osg.validate()) {
        let data = this.formData;
        data.name = data.name || new Date().getTime().toString();
        data.scriptIdentity = this.scriptIdentity;
        let params = { param: JSON.stringify(data) };
        this.osg.ajax('groovyScriptParam/upsert.do', params, () => {
          this.osg.toast('保存成功');
          this.doInit();
          this.getData();
        });
      }
    },
    doEnable(id) {
      this.osg.ajax(`groovyScriptParam/enable/${id}.do`, null, () => {
        this.osg.toast('启用成功');
        this.getData();
      });
    },
    doDisable(id) {
      this.osg.ajax(`groovyScriptParam/disable/${id}.do`, null, () => {
        this.osg.toast('禁用成功');
        this.getData();
      });
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax(`groovyScriptParam/remove/${id}.do`, null, () => {
          this.osg.toast('删除成功');
          this.getData();
        });
      });
    },
    //新增条件
    newCondition() {
      this.formData.value.conditions.push({
        type: '',
        value: ''
      });
    },
    //删除条件
    removeCondition(index) {
      this.formData.value.conditions.splice(index, 1);
    },
    //获取字典表
    getOptions(type) {
      if (type != 'area' && type != 'serviceTerritory' && type != 'workType' && type != 'channel') {
        this.options['codecfg_' + type] = { codeId: type };
        this.osg.codeoption(() => {
          this.$forceUpdate();
        });
      }
    },
    //获取服务区域
    getST(query) {
      this.osg.ajax(
        'basic/serviceTerritory/query.do',
        {
          _all: '1',
          'regex:name|string#or': query,
          'in:state|array-integer#and': '1',
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.serviceTerritory = res.data;
          this.$forceUpdate();
        },
        {
          noload: true
        }
      );
    },
    //获取工作类型
    getWorkType(query) {
      this.osg.ajax(
        'biz/workType/query.do',
        {
          _all: '1',
          'in:state|array-integer#and': '1',
          'regex:name|string#or': query,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.workType = res.data;
          this.$forceUpdate();
        },
        {
          noload: true
        }
      );
    },
    getWorkflows() {
      this.osg.ajax(
        'workflowDef/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1
        },
        res => {
          res.data.map(item => {
            item.babel = item.title;
            item.value = item._id;
          });
          this.options.workflows = res.data;
          this.$forceUpdate();
        }
      );
    },
    getNodes(workflowDefId, change) {
      if (change) {
        delete this.formData.value.nodeId;
      }
      if (this.formData.value.workflowDefId) {
        for (let workflow of this.options.workflows) {
          if (workflow._id == this.formData.value.workflowDefId) {
            this.options.nodes = workflow.def.nodes;
            this.$forceUpdate();
            return;
          }
        }
      } else {
        this.options.nodes = [];
      }
    }
  }
};
</script>
<style>
.condition-card {
  display: flex;
  justify-content: space-between;
}
.condition-card .el-card {
  width: 90% !important;
}
.condition-card .card-remove {
  width: 10%;
  text-align: center;
  color: #f2795b;
  cursor: pointer;
  font-size: 18px;
}
.automate .el-dialog__body {
  padding: 20px 30px;
}
</style>
